export function getTurnstileSiteKey() {

    if (import.meta.env.VITE_PLAYWRIGHT || import.meta.env.DEV) {
        return "1x00000000000000000000AA"
    }

    return "0x4AAAAAAAWwkcPaVQfrlp-L"
}